/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";

// MUI Imports
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

// Component Imports
import Loading from "../../../../Components/Interactive/Loading";

// Inner JSX Imports
import LoginLogsTable from "./LoginLogs/LoginLogsTable";

const CustomerLoginHistoryWidget = ({ allCustomerData, loading }) => {
  const [open, setIsOpen] = useState(false);
  const [toggleDropdown, setToggleDropdown] = useState(false);

  const {
    userLoginHistoryInfo: { loginHistoryInfo, totalLogins },
  } = allCustomerData;

  return (
    <div className="user-data-container" style={{marginBottom: "1rem"}}>
      <div className="customer-widget-header">
        <p
          className="customer-widget-heading"
          style={{ width: "100%", padding: ".5rem .5rem" }}
        >
          Customer Login History
          {loginHistoryInfo && loginHistoryInfo.length >= 0 && (
            <ArrowDropDownIcon
              onClick={() => {
                setIsOpen(!open);
                setToggleDropdown(!toggleDropdown);
              }}
              className={`arrow-dropdown ${
                toggleDropdown ? "arrow-open" : "arrow-close"
              }`}
            />
          )}
        </p>
        {!open && (
          <p className="closed-details-text">
            Total Logins - {totalLogins}
          </p>
        )}
      </div>
      <div>
        <div
          className={`${open ? "show-data-table-call" : "no-data-table-call"}`}
        >
          {loading && <Loading />}
          {loginHistoryInfo && loginHistoryInfo.length >= 0 && (
            <LoginLogsTable
              loginLogs={loginHistoryInfo}
              totalLogins={totalLogins}
              open={open}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomerLoginHistoryWidget;
